import * as yup from "yup";
import { Button, FloatingLabel, Form, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { requestPasswordResetFn } from "../../services/wp.auth.service";
import { useCallback } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";

const schema = yup.object().shape({
	email: yup.string().email().
		required()
});

const ForgotPasswordForm = ({
	onCancel
}) => {
	const {
		isLoading,
		mutate
	} = requestPasswordResetFn(useMutation);
	const navigate = useNavigate();
	const onSubmit = useCallback(({ email }) => {
		mutate(email, {
			onSuccess: () => {
				navigate("/login/forgot-success");
			}
		});
	}, [mutate]);

	return (
		<Formik
			initialValues={{
				email: ""
			}}
			onSubmit={onSubmit}
			validationSchema={schema}
		>
			{({
				errors,
				handleSubmit,
				handleChange,
				values
			}) => (
				<Form noValidate onSubmit={handleSubmit}>
					<Form.Text className="mb-5">
						Enter the email address tied to your account. You&apos;ll receive an email with instructions to reset your password.
					</Form.Text>

					<FloatingLabel className="my-4" controlId="email" label="Email address">
						<Form.Control
							isInvalid={Boolean(errors.email)}
							name="email"
							onChange={handleChange}
							placeholder="Enter email"
							required
							type="email"
							value={values.email}
						/>

						<Form.Control.Feedback type="invalid">
							{errors.email}
						</Form.Control.Feedback>
					</FloatingLabel>

					<div className="text-end">
						<Button className="me-4" onClick={onCancel} variant="outline-secondary">
							{"Cancel"}
						</Button>

						<Button className="bg-blue" disabled={isLoading} type="submit" variant="primary">
							{isLoading ? <Spinner animation="border" size="sm" /> : "Submit"}
						</Button>
					</div>
				</Form>
			)}
		</Formik>
	);
};

ForgotPasswordForm.propTypes = {
	onCancel: PropTypes.func.isRequired
};

export default ForgotPasswordForm;
